import { useList } from '../../list';

interface Params {
  departmentIds: string[];
  search?: string;
}

type Props = {
  params?: Params;
  enabled?: boolean;
};

export function useListEmployees({
  params = { departmentIds: [] },
  enabled = false,
}: Props) {
  const { data, isLoading, refetch, isFetching, isRefetching } = useList(
    'lookups/employees',
    { ...params },
    {
      enabled: enabled || (params.departmentIds?.length > 0 ? true : false),
    },
  );

  return {
    data: data?.data?.data,
    isLoading: isLoading || isFetching || isRefetching,
    refetch,
  };
}
